<template>
  <v-row>
    <v-col>
      <v-card outlined class="rounded-10" max-width="300">
        <template v-if="approval.files.length">
          <v-card-text>
            <DesignViewer :approval-files="approval.files" />
          </v-card-text>
          <v-divider />
        </template>
        <template v-if="status === 'Pending'">
          <v-card-subtitle>
            Approval options, only use after carefully reviewing design.
          </v-card-subtitle>
          <v-card-text>
            <ApproveCase :approval="approval" />
            <ApproveWithChanges :approval="approval" />
            <RequestChanges :approval="approval" />
          </v-card-text>
          <!-- <v-divider /> -->
          <v-expansion-panels accordion flat>
            <v-expansion-panel>
              <v-expansion-panel-header class="px-4">
                <v-card-subtitle class="pa-0">
                  Approval Options
                  <v-icon small>mdi-information</v-icon>
                </v-card-subtitle>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <p>
                  <small>
                    <span class="success--text font-weight-bold">
                      Approve
                    </span>
                    - The case will be finalized, no further changes. Design
                    will be uploaded for use.
                  </small>
                </p>
                <p>
                  <small>
                    <span class="warning--text font-weight-bold">
                      Approve with Changes
                    </span>
                    - For minor changes. A new field will appear for input on
                    final changes before the case is then finalized and
                    uploaded. You will not receive another design proposal for
                    review.
                  </small>
                </p>
                <p>
                  <small>
                    <span class="error--text font-weight-bold">
                      Request Changes
                    </span>
                    - For large changes. Use this option to dictate significant
                    changes, a new design proposal will be sent for review prior
                    to case finalization.
                  </small>
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-divider />
        </template>
        <template v-if="approval.approval_due_at">
          <v-card-text class="d-flex">
            <small> Approval Due At: </small>
            <v-spacer />
            <small>
              {{ approval.approval_due_at | luxon({ output: "short" }) }}
            </small>
          </v-card-text>
          <v-divider />
        </template>
        <v-card-text class="d-flex">
          <small>Status: {{ status }}</small>
          <v-spacer />
          <small v-if="approval.cancelled_at">
            {{ approval.cancelled_at | luxon({ output: "short" }) }}
          </small>
          <small v-if="approval.approved_at">
            {{ approval.approved_at | luxon({ output: "short" }) }}
          </small>
        </v-card-text>
      </v-card>
      <small>
        <span v-if="approval.created_by">
          <v-icon small> mdi-account </v-icon>
          {{ approval.created_by }}
          -
        </span>
        {{ approval.created_at | luxon({ output: "short" }) }}
      </small>
    </v-col>
  </v-row>
</template>

<script>
import DesignViewer from "./ApprovalBubble/DesignViewer.vue"
import ApproveCase from "./ApprovalBubble/ApproveCase.vue"
import ApproveWithChanges from "./ApprovalBubble/ApproveWithChanges.vue"
import RequestChanges from "./ApprovalBubble/RequestChanges.vue"

export default {
  props: ["approval"],

  components: { DesignViewer, ApproveCase, ApproveWithChanges, RequestChanges },

  computed: {
    status() {
      if (this.approval.cancelled_at) return "Cancelled"
      if (this.approval.approved_at) return "Approved"
      return "Pending"
    }
  }
}
</script>
